import * as React from "react"
import { type Operation } from "@apollo/client"
import { type GraphQLTraceStore } from "@digits-shared/helpers/createGraphQLTraceStore"

export enum GraphQLTraceKind {
  DG_MUTATION,
  ERROR,
  SLOW,
}

export interface GraphQLTrace {
  id: string
  kind: GraphQLTraceKind
  operation: Operation
  durationMS: number
  recordedAt: number
  errorCode?: string
  errorMessage?: string
  errorPath?: (string | number)[]
}

export const GraphQLTracerContext = React.createContext<GraphQLTraceStore | null>(null)

export function useGraphQLTracer() {
  const store = React.useContext(GraphQLTracerContext)
  if (!store) throw new Error("GraphQL traces require a trace store provider")
  return store
}
